import { AppFullCodeLocale, AppLocale } from '@core-types/app-locale';

export const LOCALE_FULL_CODE_MAP: Record<AppLocale, AppFullCodeLocale> = {
  en: 'en-US',
  uk: 'uk-UA',
  'es-MX': 'es-MX',
  'pt-BR': 'pt-BR',
  ka: 'ka-GE',
  ru: 'ru-RU',
  ro: 'ro-RO',
};
